import { Dialog } from '../../components/dialog-portal/dialog.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';
import { PeriodOption } from './report-settings/reportSettings.ts';

interface Props {
    period: PeriodOption;
    onClose: () => void;
}

export function ReportOperatorsDialog({ period, onClose }: Props) {
    const { data, isLoading, error } = trpc.operators.getOperatorActivityForReportDay.useQuery(
        {
            periodStart: period.start,
        },
        {
            refetchOnWindowFocus: false,
        },
    );

    const rows = data?.rows ?? [];

    return (
        <Dialog title={`Operator Activity - ${period.startLabel}`} onClose={onClose}>
            <div style={{ minWidth: 620, maxHeight: '70vh', overflowY: 'auto', paddingRight: 6 }}>
                {isLoading && <p>Loading...</p>}
                {error && <p>Failed to load operator activity.</p>}
                {!isLoading && !error && (
                    <table style={{ width: '100%', border: '1px solid #ddd' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', paddingLeft: 8 }}>Shift</th>
                                <th style={{ textAlign: 'left', paddingLeft: 8 }}>Initials</th>
                                <th style={{ textAlign: 'left', paddingLeft: 8 }}>First Action</th>
                                <th style={{ textAlign: 'left', paddingLeft: 8 }}>Latest Action</th>
                                <th style={{ textAlign: 'left', paddingLeft: 8 }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'left', padding: 8 }}>
                                        No operator activity for this day.
                                    </td>
                                </tr>
                            ) : (
                                rows.map((row) => (
                                    <tr key={`${row.shiftTeam}-${row.initials}`}>
                                        <td style={{ textAlign: 'left', padding: 8 }}>{row.shiftTeam}</td>
                                        <td style={{ textAlign: 'left', padding: 8, fontWeight: 500 }}>{row.initials}</td>
                                        <td style={{ textAlign: 'left', padding: 8 }}>{formatActionTime(row.firstActionTime)}</td>
                                        <td style={{ textAlign: 'left', padding: 8 }}>{formatActionTime(row.latestActionTime)}</td>
                                        <td style={{ textAlign: 'left', padding: 8 }}>{row.totalActions}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </Dialog>
    );
}

function formatActionTime(dateInput: string | Date): string {
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return 'n/a';

    const date = d.getFullYear() + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
    const time = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    return `${date} ${time}`;
}
